'use client';

import { ProgressProvider } from '@bprogress/next/app';

export function ProgressBarProvider({ children }: { children: React.ReactNode }) {
  return (
    <ProgressProvider
      height='2px'
      color='rgb(var(--blue-1))'
      options={{ showSpinner: false }}
      startOnLoad={false}
      stopDelay={80}
    >
      {children}
    </ProgressProvider>
  );
}
